module.exports = __webpack_public_path__ + "img/logo.fe841894.svg";